import { notifications } from '@mantine/notifications';

export const useToast = () => {
  const showSuccess = (message: string, title?: string) => {
    notifications.show({
      title,
      message,
      color: 'green',
      autoClose: 3000,
    });
  };

  const showError = (message: string, title?: string) => {
    notifications.show({
      title,
      message,
      color: 'red',
      autoClose: 5000,
    });
  };

  const showInfo = (message: string, title?: string) => {
    notifications.show({
      title,
      message,
      color: 'blue',
      autoClose: 3000,
    });
  };

  return {
    showSuccess,
    showError,
    showInfo,
  };
};
